<page-content [fullPageWidth]="true">
    <header-elitment header [hasSideMenu]="true"></header-elitment>
    <side-menu left-menu>
        <athlete-side-menu></athlete-side-menu>
    </side-menu>

    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>

    <module-content *ngIf="!isLoading && !is401 && !is404" title="{{ this.feedbackAthleteAnswer.feedback.sessionName || this.feedbackAthleteAnswer.feedback.feedbackName }}">
        <mat-card-content class="evaluation-athlete-content mb-20">
            <div class="feedback-content mb-10">{{ 'FeedbackOf' | translate:{date: (this.feedbackAthleteAnswer.feedback.answeredAt|appDate:'mediumDate')} }}</div>
        </mat-card-content>

        <div *ngFor="let key of this.feedbackAthleteAnswer.answersGrouped | keyvalue">
            <ng-template #athleteAnswerRef></ng-template>
            <mat-divider></mat-divider>
        </div>
    </module-content>
</page-content>
